import React from 'react';

import { APP_TOOLTIP_ID } from 'js/config/consts';

import ActionButton from '.';

interface ActionButtonWithA11yLabelProps {
  onClick: (event: React.MouseEvent) => void;
  id: string;
  labelText: string;
  children: React.ReactNode;
  disabled?: boolean;
}

const ActionButtonWithA11yLabel = ({
  onClick,
  id,
  labelText,
  children,
  disabled = false
}: ActionButtonWithA11yLabelProps) => {
  return (
    <span data-tip={labelText} data-for={APP_TOOLTIP_ID}>
      <label htmlFor={id} className="sr-only">
        {labelText}
      </label>
      <ActionButton onClick={onClick} id={id} disabled={disabled}>
        {children}
      </ActionButton>
    </span>
  );
};

export default ActionButtonWithA11yLabel;
